import { ComponentProps } from 'react';
import { Box } from '@startuptools/ui/Box';
import { Stack } from '@startuptools/ui/Stack';
import { IdentityDisplay } from '../identity/IdentityDisplay';
import { Menu } from '@startuptools/ui/joy/Menu';
import { Dropdown } from '@startuptools/ui/joy/Dropdown';
import { MenuButton } from '@startuptools/ui/joy/MenuButton';
import { IconButton } from '@startuptools/ui/joy/IconButton';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';

export const ProfileMenu = ({
  identityDisplayProps,
  children,
}: {
  identityDisplayProps: ComponentProps<typeof IdentityDisplay>;
  children: React.ReactNode;
}) => {
  return (
    <Stack gap={1} direction="row">
      <Box minWidth={0} width={200}>
        <IdentityDisplay {...identityDisplayProps} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Dropdown>
          <MenuButton slots={{ root: IconButton }}>
            <UnfoldMoreIcon />
          </MenuButton>
          <Menu placement="top-start">{children}</Menu>
        </Dropdown>
      </Box>
    </Stack>
  );
};
